import React, { Component } from 'react'
import { render } from 'react-dom'
import axios from 'axios'

class FavouriteApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      favourites: [],
      favourited: false,
      xcsrf: ''
    }
    this.getMembershipCookie = this.getMembershipCookie.bind(this)
    this.afterAjax = this.afterAjax.bind(this)
  }

  getMembershipCookie() {
    var value = "; " + document.cookie;
    var parts = value.split("; irewards_membership_number=");
    if (parts.length >= 2) {
      return parts.pop().split(";").shift();
    }
    else {
      return 0;
    }
  }

  afterAjax() {
    this.setState({ ajax_rerender: 1 })
  }

  componentDidMount() {
    let config = {
      headers: {
        'Content-Type': 'application/vnd.api+json'
      }
    }

    var base_url = window.location.origin;
    let membership_id = this.getMembershipCookie();
    if (membership_id) {
      const uri = base_url + '/api/favourite/favourite?filter[ghs_membership_id][value]=' + membership_id + '&filter[site_url][value]=' + base_url;
      const encoded = encodeURI(uri);

      axios.get(base_url + '/session/token', config)
        .then((response) => {
          this.setState({ xcsrf: response.data })
        })

      axios.get(encoded, config)
        .then((response) => {
          // handle success
          this.setState({ favourites: response.data })
        })
        .catch(function (error) {
          // handle error
        })
        .finally(function () {
          // always executed
        });
    }
    document.addEventListener('ajaxCompletion', this.afterAjax);
  }

  render() {
    let membership_id = this.getMembershipCookie();

    let tileTops = Array.from(document.querySelectorAll('.tile__top-second'));
    return tileTops.map( (item, i) => {
      var entity_id;
      var entity_type;
      entity_id = item.getAttribute('data-attr-id')
      entity_type = item.getAttribute('data-attr-type')

      var favourited = false;
      var uuid = 0;
      if (this.state.favourites.data) {
        for (i = 0; i < this.state.favourites.data.length; i++) {
          if (this.state.favourites.data[i].attributes.entity_id == entity_id && this.state.favourites.data[i].attributes.entity_type == entity_type) {
            favourited = true;
            uuid = this.state.favourites.data[i].id;
          }
        }
      }
      var xcsrf = this.state.xcsrf
      return <FavouriteButton key={ i + Math.random() } favouriteContainer={item} favourited={favourited} uuid={uuid} xcsrf={xcsrf}
                              getMembershipCookie={membership_id}/>
    });
  }
}

class FavouriteButton extends Component {
  constructor (props) {
    super(props)
    this.state = {
      favouriteContainer: props.favouriteContainer,
      favourited: this.props.favourited,
      uuid: this.props.uuid,
      xcsrf: this.props.xcsrf
    }
  }

  handleToggleFavourite = (e) => {
    e.preventDefault()
    // Display popup if membership cookie is not set.
    if (!parseInt(this.props.getMembershipCookie)) {
      var confirmationDialog = Drupal.dialog(drupalSettings.get_more_block, {
        dialogClass: 'get-more-with',
        resizable: false,
        closeOnEscape: false,
        beforeClose: false,
        close: function (event) {
          jQuery(event.target).remove();
          jQuery('html').css({
            'overflow': '',
            'box-sizing': '',
            'padding-right': ''
        });
        }
      });
      confirmationDialog.showModal();
      return;
    }
    var tileLink = this.props.favouriteContainer.getAttribute('data-url');

    if (!(tileLink)) {
      var linkWrapper = jQuery(this.props.favouriteContainer).parent().parent().parent().children(".tile__link-wrapper");
      tileLink = jQuery(linkWrapper[0]).attr("href");
    }

    var tileTitle = jQuery(this.props.favouriteContainer).parent().siblings(".tile_bottom").children(".tile__bottom-first").children(".tile--title").text();
    if (typeof tileTitle == 'undefined' || tileTitle == null || tileTitle == "") {
      tileTitle = jQuery(this.props.favouriteContainer).parent().siblings(".tile_bottom").children(".tile__bottom-first").children(".tile--upcoming-title").text();
    }
    if (typeof tileTitle == 'undefined' || tileTitle == null || tileTitle == "") {
      tileTitle = jQuery(this.props.favouriteContainer).parent().siblings(".tile_bottom").children(".tile__bottom-first").children(".title-favourites").text();
    }
    if (typeof tileTitle == 'undefined' || tileTitle == null || tileTitle == "") {
      tileTitle = jQuery(this.props.favouriteContainer).parent().siblings(".tile-3__bottom").children(".title-favourites").text().trim().replace(/\n/g, '');
    }

    var tileDesc = jQuery(this.props.favouriteContainer).parent().siblings(".tile_bottom").children(".tile__bottom-first").children(".desc-favourites").text();
    if (typeof tileDesc == 'undefined' || tileDesc == null || tileDesc == '') {
      tileDesc = jQuery(this.props.favouriteContainer).parent().siblings(".tile_bottom").children(".tile__bottom-first").children(".tile__bottom-first--link").text().trim().replace(/\n/g, '');;
    }

    let type = this.props.favouriteContainer.getAttribute('data-attr-type');
    let tileEntityBundle = this.props.favouriteContainer.getAttribute('data-attr-bundle');
    let tileEntityId = this.props.favouriteContainer.getAttribute('data-attr-id');
    let tileFastookingId = this.props.favouriteContainer.getAttribute('data-fastbooking-id');
    let tileTripAdviserId = this.props.favouriteContainer.getAttribute('data-trip-adviser-id');
    let bottomFirstPrice = this.props.favouriteContainer.getAttribute('data-bottom-first-price');
    let dataTopFirst = this.props.favouriteContainer.getAttribute('data-top-first');
    let dataHoverSection = this.props.favouriteContainer.getAttribute('data-hover-section');
    let dataHoverLocation = this.props.favouriteContainer.getAttribute('data-hover-location');
    var dataDiscountPercent = '';
    var dataSalesCount = '';
    var dataCostPrice = '';
    var dataSalePrice = '';
    var dataUrl = '';
    var dataPoints = '';
    var dataLocation = '';
    var dataLocationUrl = '';
    var dataProductTitleFavourite = '';
    var tileImage = '';
    var topRestaurantFavourite = '';
    var outletRestaurantFavourite = '';
    var diningTitle = '';
    var diningPrice = '';
    var diningCuisine = '';
    var diningDesc = '';
    var diningBgImage = '';
    var diningLogo = '';
    var dataBottomFirstPrice = '';
    var favouriteOfferTop = '';
    var hoteLinkOfferFavourite = '';
    if (type == 'node') {
      if(tileEntityBundle === "product") {
        dataDiscountPercent = this.props.favouriteContainer.getAttribute('data-discount-percent');
        dataSalesCount = this.props.favouriteContainer.getAttribute('data-sales-count');
        dataCostPrice = this.props.favouriteContainer.getAttribute('data-cost-price');
        dataSalePrice = this.props.favouriteContainer.getAttribute('data-sale-price');
        dataUrl = this.props.favouriteContainer.getAttribute('data-url');
        dataPoints = this.props.favouriteContainer.getAttribute('data-points');
        dataLocation = this.props.favouriteContainer.getAttribute('data-location');
        dataLocationUrl = this.props.favouriteContainer.getAttribute('data-location-url');
        dataProductTitleFavourite = this.props.favouriteContainer.getAttribute('data-product-title-favourite');
        topRestaurantFavourite = this.props.favouriteContainer.getAttribute('top_restaurant_favourite');
        outletRestaurantFavourite = this.props.favouriteContainer.getAttribute('outlet_restaurant_favourite');
      }
      if(tileEntityBundle === "favourite_offer_top") {
        favouriteOfferTop = this.props.favouriteContainer.getAttribute('favourite_offer_top');
        hoteLinkOfferFavourite = this.props.favouriteContainer.getAttribute('hotel_link_offer_favourite');
      }
      if(tileEntityBundle === "dining_concept") {
        diningTitle = this.props.favouriteContainer.getAttribute('dining_title');
        diningPrice = this.props.favouriteContainer.getAttribute('dining_price');
        diningCuisine = this.props.favouriteContainer.getAttribute('dining_cuisine');
        diningDesc = this.props.favouriteContainer.getAttribute('dining_desc');
        diningBgImage = this.props.favouriteContainer.getAttribute('dining_bg_image');
        diningLogo = this.props.favouriteContainer.getAttribute('dining_logo');
      }
      if(tileEntityBundle === "restaurant") {
        dataBottomFirstPrice = this.props.favouriteContainer.getAttribute('data-bottom-first-price');
      }
    }
    
    var tileImages = jQuery(this.props.favouriteContainer).parent().siblings(".tile__image");
    if (tileImages.length) {
      tileImage = jQuery(tileImages[0]).css('background-image').replace( /url\(|\)/g, '' );
    }
    else {
      if(tileEntityBundle !== "job") {
        tileImages = jQuery(this.props.favouriteContainer).parent().siblings(".tile-3__image");
        tileImage = jQuery(tileImages[0]).css('background-image').replace( /url\(|\)/g, '' );
      }
    }

    var tileData = {
      "tileTitle": tileTitle,
      "tileDesc": tileDesc,
      "tileImage": tileImage,
      "tileLink": tileLink,
      "tileEntityType": type,
      "tileEntityBundle": tileEntityBundle,
      "tileEntityId": tileEntityId,
      "tileEntityFastbookingId": tileFastookingId,
      "tileTripAdviserId": tileTripAdviserId,
      "bottomFirstPrice": bottomFirstPrice,
      "dataTopFirst": dataTopFirst,
      "dataDiscountPercent": dataDiscountPercent,
      "dataSalesCount": dataSalesCount,
      "dataCostPrice": dataCostPrice,
      "dataSalePrice": dataSalePrice,
      "dataUrl": dataUrl,
      "dataPoints": dataPoints,
      "dataLocation": dataLocation,
      "dataLocationUrl": dataLocationUrl,
      "dataProductTitleFavourite": dataProductTitleFavourite,
      "dataHoverSection": dataHoverSection,
      "dataHoverLocation": dataHoverLocation,
      "diningTitle": diningTitle,
      "diningPrice": diningPrice,
      "diningCuisine": diningCuisine,
      "diningDesc": diningDesc,
      "diningBgImage": diningBgImage,
      "diningLogo": diningLogo,
      "dataBottomFirstPrice": dataBottomFirstPrice,
      "topRestaurantFavourite": topRestaurantFavourite,
      "outletRestaurantFavourite": outletRestaurantFavourite,
      "favouriteOfferTop": favouriteOfferTop,
      "hoteLinkOfferFavourite": hoteLinkOfferFavourite,
    };

    const { favourited } = this.state.favourited
    // API call post.
    var base_url = window.location.origin;
    let config = {
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
        'X-CSRF-Token': this.state.xcsrf
      }
    }
    if (this.state.favourited) {
      let url = base_url + '/api/favourite/favourite/' + this.state.uuid;
      // Set favourited to false. If there is error then we make favourited
      // true. This is to make favourite experience instant.
      this.setState({
        favourited: false
      })
      axios.delete(url, config)
        .then((response) => {
          // handle success
        })
        .catch(function (error) {
          this.setState({
            favourited: true
          })
          // handle error
        })
        .finally(function () {
          // always executed
        });
    }
    else {
      let config = {
        headers: {
          'Content-Type': 'application/vnd.api+json',
          'Accept': 'application/vnd.api+json',
          'X-CSRF-Token': this.state.xcsrf
        }
      }
      var entity_id = this.props.favouriteContainer.getAttribute('data-attr-id')
      var entity_type = this.props.favouriteContainer.getAttribute('data-attr-type')
      var entity_bundle = this.props.favouriteContainer.getAttribute('data-attr-bundle')
      var entity_uuid = this.props.favouriteContainer.getAttribute('data-attr-uuid')
      var relationships = null;
      if (entity_type == 'term' && entity_bundle) {
        relationships = {
          "master_site_term_entity": {
            "data": {
              "type": "taxonomy_term--" + entity_bundle,
              "id": entity_uuid
            }
          }
        }
      }

      let data = {
        "data": {
          "type": "favourite--favourite",
          "attributes": {
            "site_url": base_url,
            "ghs_membership_id": parseInt(this.props.getMembershipCookie),
            "entity_id": parseInt(entity_id),
            "entity_type": entity_type,
            "entity_bundle": entity_bundle,
            "tile_data": JSON.stringify(tileData)
          }
        }
      }
      if (relationships != null) {
        data.data.relationships = relationships;
      }
      var base_url = window.location.origin;
      let url = base_url + '/api/favourite/favourite';
      // Set favourited true before post and if there is error then make
      // favourite false. This is to make favourite experience instant.
      this.setState({
        favourited: true
      })
      axios.post(url, data, config)
        .then((response) => {
          // handle success
          this.state.uuid = response.data.data.id;
        })
        .catch(function (error) {
          // handle error
          this.setState({
            favourited: false
          })
        })
        .finally(function () {
          // always executed
        });
    }
  }
  componentDidUpdate(prevProps){
    if(prevProps.favourited !== this.props.favourited){
      this.setState({
        favourited: this.props.favourited
      });
    }
    if(prevProps.uuid !== this.props.uuid){
      this.setState({
        uuid: this.props.uuid
      });
    }
  }

  render () {
    return ReactDOM.createPortal(
      <a
        href='#'
        className={this.state.favourited ? 'favourited' : 'not-favourited'}
        onClick={this.handleToggleFavourite}
      >
        {this.state.favourited ? <span className="icon__wrapper"><svg className="icon icon--commands-favourite-added size_18" focusable="false" role="img" title="Favorite added icon" xmlnsXlink="http://www.w3.org/1999/xlink"><use xlinkHref="#commands-favourite-added"></use></svg></span> : <span className="icon__wrapper"><svg className="icon icon--commands-favourite-empty size_18" focusable="false" role="img" title="Favorite empty icon" xmlnsXlink="http://www.w3.org/1999/xlink"><use xlinkHref="#commands-favourite-empty"></use></svg></span>}
      </a>,
      this.props.favouriteContainer
    )
  }
}

export default FavouriteApp
render(<FavouriteApp />, document.getElementById('block-favouritebutton'));
